import { useEffect, useState } from 'react';
import { Button, Paper, TextField, Typography, Grid2, Stack } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { setSelectedTemplateType, setForecastStatus, setForecastNote, setAllReviewed } from '../../../../../features/forecastersSlice';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserWebsitePermissions, setIsLoading } from '../../../../../features/userSlice';

const DuplicateForeCastBase = ({ selectedForecaster, loading }: any) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedYear = searchParams.get("selectedYear") as any;
  const selectedDuplicateForecast = useSelector((state: any) => state?.forecasters?.selectedDuplicateForecast);
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const forecastNote = useSelector((state: any) => state?.forecasters?.forcastNote);
  const selectedSite = searchParams.get("selectedSite") as any;
  const [, setVersion] = useState("");
  const [, setTemplateType] = useState("");

  const handleCancelClick = () => {
    navigate(`/assets/overview/forecaster${location.search}`);
    dispatch(setSelectedTemplateType(null));
    dispatch(setAllReviewed(false));
    dispatch(setForecastStatus(null));
    dispatch(setForecastNote(""));
    dispatch(setIsLoading(false));
  };

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    if (location.pathname === "/assets/overview/forecaster/DuplicateForecast" && newSearchParams.get("page") !== "0") {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  useEffect(() => {
    if (selectedDuplicateForecast && selectedForecaster) {
      setVersion(selectedForecaster?.version);
      if (selectedForecaster.notes) {
        dispatch(setForecastNote(selectedForecaster.notes));
      }
      setTemplateType(selectedDuplicateForecast.template_type);
    }
  }, [dispatch, selectedDuplicateForecast, selectedForecaster]);

  const getTemplateType = (type: any) => {
    dispatch(setSelectedTemplateType(type));
    const templateTypes: Record<any, any> = {
      1: "FTD",
      2: "Growth",
      3: "Profit",
    };
    return templateTypes[type] || "N/A";
  };

  return (
    <>
      <Paper sx={{ padding: "8px 16px" }}>
        <Grid2 container spacing={2} alignItems={"center"} mb={2}>
          <Grid2>
            <Stack flexDirection={"row"} alignItems={"center"} gap={2}>
              <Typography variant="h5" fontWeight={400}>
                Duplicate Forecast
              </Typography>
            </Stack>
          </Grid2>
          <Grid2>
            <Grid2 container spacing={2}>
              <Grid2 size={4}>
                <Stack flexDirection={"row"} gap={0.5}>
                  <Typography fontWeight={500}>Asset:</Typography>
                  <Typography fontWeight={400}>
                    {websitePermissions.find((site: any) =>
                      Object.keys(site)[0] === selectedSite
                    )?.[selectedSite]?.ui_site_name}
                  </Typography>
                </Stack>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 container alignItems="center" spacing={2} sx={{ whiteSpace: "nowrap" }} mt={1} justifyContent={"space-between"}>
          <Grid2 size={8} alignItems={"center"} flexDirection={"row"}>
            <Grid2 container spacing={2}>
              {/* Year */}
              <Grid2 size={2}>
                <Typography variant="body2" color="textSecondary">
                  Year
                </Typography>
                <Typography variant="body1">{selectedYear}</Typography>
              </Grid2>
              {/* Version */}
              <Grid2 size={1}>
                <Typography variant="body2" color="textSecondary">
                  Version
                </Typography>
                <Typography variant="body1">{selectedForecaster?.version + 1}</Typography>
              </Grid2>
              {/* Prediction Focus */}
              <Grid2 size={3}>
                <TextField
                  size="small"
                  label="Prediction Focus"
                  fullWidth
                  color="secondary"
                  variant="outlined"
                  disabled
                  value={getTemplateType(selectedForecaster?.template_type)}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid2>
              {/* Note */}
              <Grid2 size={4}>
                <TextField
                  fullWidth
                  color="secondary"
                  label="Note"
                  variant="outlined"
                  value={forecastNote || selectedForecaster?.notes}
                  disabled={loading}
                  onChange={(e) => dispatch(setForecastNote(e.target.value))}
                  size="small"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
          {/* Button */}
          <Grid2>
            <Stack direction="row" spacing={2}>
              <Button color="secondary" disabled={loading} variant="text">
                <Stack onClick={handleCancelClick}>Cancel</Stack>
              </Button>
              <Button variant="outlined" color="secondary" onClick={() => dispatch(setForecastStatus('draft'))} disabled={loading} >
                Save as draft
              </Button>
              <Button variant="contained" color="secondary" endIcon={<SaveIcon />} onClick={() => dispatch(setForecastStatus('publish'))} disabled={loading} >
                Save & Publish
              </Button>
            </Stack>
          </Grid2>
        </Grid2>
      </Paper>
    </>
  )
}

export default DuplicateForeCastBase
